import { useCallback } from "react";
import * as XLSX from "xlsx";
import toast from "react-hot-toast";

interface ExportOptions {
  data: Record<string, unknown>[];
  filename?: string;
  sheetName?: string;
  showToast?: boolean;
}

export const useExcelExport = () => {
  const exportToExcel = useCallback(
    ({
      data,
      filename = "export",
      sheetName = "Sheet1",
      showToast = true,
    }: ExportOptions) => {
      if (!data || data.length === 0) {
        if (showToast) {
          toast.error("No data available for export");
        }
        throw new Error("No data available for export");
      }

      try {
        const wb = XLSX.utils.book_new();
        const ws = XLSX.utils.json_to_sheet(data);
        XLSX.utils.book_append_sheet(wb, ws, sheetName);
        const fullFilename = `${filename}_${new Date().toISOString().split("T")[0]}.xlsx`;
        XLSX.writeFile(wb, fullFilename);
        if (showToast) {
          toast.success("Excel file exported successfully");
        }
      } catch (error) {
        if (showToast) {
          toast.error("Failed to export Excel file");
        }
        console.error("Export error:", error);
        throw error;
      }
    },
    [],
  );

  return { exportToExcel };
};
